import { db } from '../firebaseConfig'; 
import { collection, addDoc } from 'firebase/firestore';

const agregarContacto = ({nombreContacto, apellidoContacto, correo, telefono, nombreCompania, descripcion, uidUsuario}) => {
    return addDoc(collection(db, 'calochocontactanospage'), {
        nombreContacto: nombreContacto,
        apellidoContacto: apellidoContacto,
        correo: correo,
        telefono: telefono,
        nombreCompania: nombreCompania,
        descripcion: descripcion,
		uidUsuario: uidUsuario
    });
}

export default agregarContacto;